module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2018/june-10b4b9372ede4e2a850251c9fc515291.png";